module.exports = __webpack_public_path__ + "img/Comic03-5.19927e10.png";